export default {
  translation: {
    common: {
      accept: '接受',
      alreadyUser: '已经是用户？',
      and: '和',
      backToLogin: '返回登录页面',
      continueWith: '使用 {{provider}} 继续',
      coreNotFound: '获取核心设置失败',
      createAccount: '创建账户',
      createYourAccount: '创建你的账户',
      emailOrUsername: '邮箱或用户名',
      invalidUsernameOrPassword: '用户名或密码无效',
      localRegistrationDisabled: '管理员已禁用本地用户注册',
      login: '登录',
      logInToBoards: '登录',
      newToBoards: '刚来到 4ga Boards?',
      noInternetConnection: '无网络连接',
      pageNotFound_title: '页面未找到',
      password: '密码',
      policyNotAccepted: '请接受服务条款和隐私政策',
      privacyPolicy: '隐私政策',
      register: '注册',
      registerWithGoogle: '使用 Google 注册',
      registrationDisabled: '管理员已禁用所有用户注册',
      serverConnectionFailed: '服务器连接失败',
      ssoRegistrationDisabled: '管理员已禁用 SSO 注册',
      termsOfService: '服务条款',
      togglePasswordVisibility: '切换密码可见性',
      unknownError: '未知错误，请稍后再试',
    },

    action: {
      logIn: '登录',
    },
  },
};
